import { PnlDataVersion } from 'src/components/star-grid/reportSelectors.types';

export const isIcebergVersion = (version: PnlDataVersion): boolean =>
  version.source === 'iceberg' || (!version.source && Boolean(version.snapshot_id));

export const isHotTaggedVersion = (version: PnlDataVersion): boolean => version.source === 'prophecy' && version.status?.toLowerCase() === 'hot';

export const isVisibleVersion = (version: PnlDataVersion): boolean => version.source !== 'prophecy' || isHotTaggedVersion(version);

export const versionCatalogKey = (version: PnlDataVersion): string => `${version.source ?? ''}:${version.snapshot_id ?? version.version}`;
